import styled, { css } from "styled-components";

const SliderButtonContainer = styled.div`
    font-size: 50px;
    position: absolute;
    top: 38%;
    z-index: 5;
    color: #fff;
    left: -15px;
    right: -18px;
    justify-content: space-between;
    display: flex;

    @media (max-width: 576px) {
        top: 36%;
        display: none;
    }

    @media (max-width: 768px) and (min-width: 577px) {
        top: 34%;
        left: -10px;
        right: -10px;
    }

    @media (max-width: 1024px) and (min-width: 770px) {
        top: 28%;
    }

    @media (max-width: 1280px) and (min-width: 1025px) {
        top: 30%;
    }

    @media (min-width: 1900px) {
        top: 45%;
    }
`;
export default SliderButtonContainer;
